import React from 'react';
import { Modal, Table } from 'antd';
import SeoForm from './SeoForm'
// import { clearCache } from '../../utils/clearCache';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import moment from 'moment-jalaali';
import strings from "../../utils/strings";

export default function ShowSeoHistory({ businessToken,setSeoHistory, seoHistory }) {
    // console.log({seoHistory})
    const general = useGeneralStore();
    const loading =false
    const { business } = usePersistedStore()
    const visible = general.view.seoHistoryModule;
    const selectedHead = business.businesses.selectedHead;

    const columns = [
        {
            title: "آدرس",
            dataIndex: "url",
            key: "url",
            width: 100,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "عنوان",
            dataIndex: "title",
            key: "title",
            width: 100,
            render: (text) => <span >{text}</span>,
        },
        {
            title: "توضیحات",
            dataIndex: "description",
            key: "description",
            width: 600,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "متا تگ ها",
            dataIndex: "metaTags",
            width: 200,
            key: "metaTags",
            render: (text) => <span>{text}</span>,
        },
        {
            title: "کنونیکال",
            dataIndex: "canonical",
            key: "canonical",
            width: 100,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "فالو",
            dataIndex: "followStatus",
            width: 200,
            key: "followStatus",
            render: (text) => {

                return (<div>
                    <span>{text == null && "مقدار پیش فرض"}</span>
                    <span>{text == 0 && "NoFollow"}</span>
                    <span>{text == 1 && "Follow"}</span>
                </div>
                )
            }

        },
        {
            title: "تاریخ ویرایش",
            dataIndex: "updatedAt",
            key: "updatedAt",
            width: 150,
            // sorter: (a, b) => {
            //     let first = '';
            //     let second = '';
            //     a.updatedAt ? first = a.updatedAt : first = '';
            //     b.updatedAt ? second = b.updatedAt : second = '';
            //     return first.localeCompare(second)
            // },
            render: data => strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm  "))
        },
        
    ];

    return (
        <Modal
            style={{
                top: 25,
            }}
            className="custom-table seo-history-modal"
            title="تاریخچه سئو"
            visible={visible}
            destroyOnClose={true}
            footer={false}
            onCancel={() => {general.ToggleSeoHistoryModal()
                setSeoHistory([])
                
            }}>
            <Table
                className="custom-table"
                style={{ paddingTop: "20px", overflowX: "scroll" }}
                bordered
                columns={columns}
                loading={loading}
                dataSource={seoHistory}
                // dataSource={heads}
                scroll={true}
                rowKey="url"
                />
        </Modal>
    )
}
